import { render, staticRenderFns } from "./LayoutCard.vue?vue&type=template&id=2d5e24ea&scoped=true&"
import script from "./LayoutCard.vue?vue&type=script&lang=js&"
export * from "./LayoutCard.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCard.vue?vue&type=style&index=0&id=2d5e24ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e24ea",
  null
  
)

export default component.exports